import type { AxiosInstance } from 'axios';
import { createCrudService, type CrudService } from '../core/crud';
import type { TicketResponse, TicketResponseCreate, TicketResponseFilter } from '../data/ticketResponse';

export function createTicketResponseService(client: AxiosInstance) {
  return createCrudService<TicketResponse, TicketResponseCreate, TicketResponseFilter>(
    client,
    '/crm/TicketResponse',
    'id',
  );
}

export type TicketResponseService = CrudService<TicketResponse, TicketResponseCreate, TicketResponseFilter>;
